export const OrderType = {
  INSTORE: 0,
  DELIVERY: 1,
  TAKE_AWAY: 2,
  ONLINE_DELIVERY: 3,
  PICK_UP: 4, 
};